import {
  Component,
  ViewEncapsulation,
  OnInit,
  Inject
} from '@angular/core';

import {
  FormBuilder,
  Validators,
  FormGroup,
  FormControl
} from '@angular/forms';

import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-card-dialog',
  encapsulation: ViewEncapsulation.None,
  templateUrl: 'card-dialog.template.html'
})

export class CardDialogComponent implements OnInit {
  public form: FormGroup;
  public formErrors = {
    number: '',
    name: '',
    postal: '',
    month: '',
    year: '',
    cvc: ''
  };

  constructor(private formBuilder: FormBuilder,
              public dialogRef: MatDialogRef<CardDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  public ngOnInit(): void {
    this.buildForm();
  }

  public buildForm() {
    this.form = this.formBuilder.group({
      // exp_month:$scope.selectedCard.exp_month,
      // exp_year:$scope.selectedCard.exp_year

      number: new FormControl( this.data ? `**** ${this.data.last4}` : '', [
        Validators.required,
        Validators.minLength(this.data ? 0 : 15)
      ]),
      exp_month: new FormControl(this.data ? this.data.exp_month : '', [
        Validators.required
      ]),
      exp_year: new FormControl(this.data ? this.data.exp_year : '', [
        Validators.required
      ]),
      name: new FormControl(this.data ? this.data.name : '', [
        Validators.required,
        Validators.minLength(3)
      ]),
      cvc: new FormControl('', [
        Validators.required,
        Validators.minLength(3)
      ]),
      address_zip: new FormControl(this.data ? this.data.address_zip : '', [
        Validators.required,
        Validators.minLength(5)
      ])
    });
  }

  public save(value: any) {
    this.dialogRef.close(this.form.value);
  }

}
